import emailjs from 'emailjs-com';

// Configuración de EmailJS (obtienes estos valores de tu dashboard)
const EMAIL_CONFIG = {
  serviceId: 'service_0t7i4yx',    // Tu Service ID
  templateId: 'template_wp3434n',  // Tu Template ID  
  publicKey: '5goA8bLeyF5vHY1wP'        // Tu Public Key
};

// Función para enviar email de contacto
export const sendContactEmail = async (formData) => {
  try {
    const templateParams = {
      from_name: formData.name,
      from_email: formData.email,
      company: formData.company || 'No especificada',
      message: formData.message,
      to_email: 'infinituxservices@gmail.com', // Tu email donde llegarán los mensajes
      reply_to: formData.email
    };

    const result = await emailjs.send(
      EMAIL_CONFIG.serviceId,
      EMAIL_CONFIG.templateId,
      templateParams,
      EMAIL_CONFIG.publicKey
    );

    return {
      success: true,
      message: 'Email enviado correctamente',
      data: result
    };

  } catch (error) {
    console.error('Error enviando email:', error);
    
    return {
      success: false,
      message: 'Error al enviar el email',
      error: error
    };
  }
};

// Función para enviar email de confirmación al cliente (opcional)
export const sendConfirmationEmail = async (formData) => {
  try {
    const templateParams = {
      to_name: formData.name,
      to_email: formData.email,
      company_name: 'INFINITUX SOLUTIONS'
    };

    const result = await emailjs.send(
      EMAIL_CONFIG.serviceId,
      'template_confirmation', // Template diferente para confirmación
      templateParams,
      EMAIL_CONFIG.publicKey
    );

    return { success: true, data: result };

  } catch (error) {
    console.error('Error enviando confirmación:', error);
    return { success: false, error: error };
  }
};